import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import React from 'react'

// ═══════════════════════════════════════════════════════════════════════════
// Types
// ═══════════════════════════════════════════════════════════════════════════

export interface CardHeaderTitleProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode
}

// ═══════════════════════════════════════════════════════════════════════════
// Component
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Styled title component for CardHeader.
 * Uses UIkit Text.SmallCaps2 for consistent typography.
 *
 * @example
 * <CardHeader>
 *   <CardHeaderTitle>ITEM 1</CardHeaderTitle>
 *   <DeleteButton onClick={handleDelete} />
 * </CardHeader>
 */
const CardHeaderTitle = React.memo(
  ({ children, style, className, ...props }: CardHeaderTitleProps) => {
    const [css] = useStyletron()

    // Merge style into className for UIkit Text component
    const mergedClassName = style
      ? `${css(style as any)} ${className || ''}`
      : className || ''

    return (
      <Text.SmallCaps2
        tag="span"
        bold
        color="grey60"
        className={mergedClassName}
        {...props}
      >
        {children}
      </Text.SmallCaps2>
    )
  }
)

CardHeaderTitle.displayName = 'CardHeaderTitle'

export default CardHeaderTitle
